export class SingleBlogController {
    constructor($scope, $rootScope, $route, UserService, BlogService, PaymentService, toastr, socket) {
        $scope.vm = this;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.route = $route;
        this.toastr = toastr;
        this.socket = socket;
        this.UserService = UserService;
        this.BlogService = BlogService;
        this.PaymentService = PaymentService;
        this.init();
    }

    init() {
        this.blogId = this.route.current.params.id;
        this.scope.loading = false;
        this.scope.pagin = {page: 1, pageCount: 0, limit: 12, maxItem: 0};
        this.scope.comments = [];
        this.scope.newComment = {content: ""};

        this.scope.isVip = () => {
            return this.rootScope.isVip() && this.rootScope.currentUserProfile.usertype === +'4';
        };

        this.scope.canLoadMore = () => {
            return this.scope.pagin.pageCount >= this.scope.pagin.page;
        };

        this.UserService.getCurrentUser()
            .then((response) => { let user = response.data;
                if(!user.success) {  
                        this.rootScope.unregister = true
                    }
                this.rootScope.currentUserProfile = user.data;
            })
            .catch((response) => { let error = response.data;
                this.rootScope.unregister = true;
                console.log(error);
            });

        this.getBlog();
        this.loadMore();

        this.socket.on(`add_comment_${this.blogId}`, (json_data) => {
            let data = JSON.parse(json_data);
            this.scope.blog.commentsCount++;
            this.scope.comments.unshift(data);
            this.scope.comments = _.uniqBy(this.scope.comments, item => item._id);
        });

        this.socket.on(`add_comment_like_${this.blogId}`, (json_data) => {
            let data = JSON.parse(json_data);
            let userId = this.rootScope.currentUserProfile._id;
            let comment = _.find(this.scope.comments, item => `${item._id}` === `${data.comment}`);
            if(data.type === 1) {
                comment.like.push(userId);
            } else {
                comment.unlike.push(userId);
            }
        });
    }

    getBlog() {
        this.BlogService.getSelectBlog(this.blogId)
            .then((_res) => { let response = _res.data;
                this.scope.blog = response.data;
                this.scope.isLoadedPage = true;
            })
            .catch((response) => { let err = response.data;
                console.log(err);
                this.scope.isLoadedPage = true;
            })
    }

    loadMore() {
        if(this.scope.loading) return;
        this.scope.loading = true;
        this.BlogService.getSelectBlogComments(this.blogId, this.scope.pagin.page, this.scope.pagin.limit)
            .then((_res) => { let response = _res.data;
                this.scope.pagin.maxItem = response.itemCount;
                this.scope.pagin.pageCount = response.pageCount;
                this.scope.comments = this.scope.comments.concat(response.data);
                this.scope.comments = _.uniqBy(this.scope.comments, item => item._id);
                this.scope.pagin.page++;
                this.scope.loading = false;
            })
            .catch((response) => { let err = response.data;
                this.scope.loading = false;
                console.error(err);
            })
    }

    addComment() {
        if (this.scope.isVip()) {
            if (!this.scope.newComment.content || this.scope.newComment.content.length == 0) {
                this.toastr.warning("No se puede enviar un comentario vacío");
            } else {
                let data = {blog: this.blogId, content: this.scope.newComment.content};
                this.socket.emit('create_comment', JSON.stringify(data));
                this.scope.newComment.content = "";
            }
        } else {
            this.toastr.error("Usted no se ha VIP para añadir comentarios");
        }
    }

    commentLike(comment, type = 1) {
        let userId = this.rootScope.currentUserProfile._id;
        if(comment.user._id === userId) return;

        if (_.includes(comment.like, userId) || _.includes(comment.unlike, userId)) {
            this.toastr.warning("Ya califaste este comentario");
            return;
        }

        const data = {blog: this.blogId, comment: comment._id, type: type};
        this.socket.emit('create_comment_like', JSON.stringify(data));
    }

    reportarComentario(comment) {
        if (this.rootScope.currentUserProfile._id != comment.user._id) {
            let params = {
                comment: comment,
                blog: this.blogId,
                applicant: this.rootScope.currentUserProfile._id
            };

          this.BlogService.createReport(params)
              .then((_res) => { let response = _res.data;
                  if (response.data.alreadyExists) {
                      this.toastr.info("Existe Su respuesta");
                  } else {
                      this.toastr.info("El reporte fue enviado");
                  }
              })
              .catch((response) => { let error = response.data;
                  console.log(error);
              });
        }
    }
}
